import {CUSTOMER_DATA_GA4_EVENT} from '@aboutyou/legacy-tracking-sdk/src/ay-tracking/providers/gtm/trackingHandlers/trackCustomerData';
import {waitUntil} from '@aboutyou/utils';

export const waitUntilCustomerDataEvent = (cb: VoidFunction) => {
  const {waiter: waiterUntilCustomerDataTracked} = waitUntil(() =>
    window.dataLayer.some(
      (item: any) => item.event === CUSTOMER_DATA_GA4_EVENT,
    ),
  );

  waiterUntilCustomerDataTracked.then(() => cb());
};
